import { Box, Button, Paper, Typography } from '@mui/material';
import React, { useEffect, useState, useRef } from 'react';
import UTurnLeftIcon from '@mui/icons-material/UTurnLeft';

import Grid from '@mui/material/Grid2';
import { useNavigate, useParams } from 'react-router-dom';
import { useStore } from '../../utils/store';
import Constants from '../../utils/constants';
import HttpServices from '../../services/HttpService';
import SimpleDialogComponent from '../../components/SimpleDialogComponent';

import { useSearch } from '../../components/searchContext';
import AlertMessageComponent from '../../components/AlertMessageComponent';
import { useAlert } from '../../components/alertContext';
import CustomPaginationActionsTable from '../../components/TablePagination';
import TextFieldComponent from '../../components/form/TextFieldComponent';
import AddButtonComponent from '../../components/form/AddButtonComponent';
import ButtonComponent from '../../components/form/ButtonComponent';
import { IconButton, SortDirection, Tooltip } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
const ReceiptingDetails: React.FC = () => {
  const isInitialLoad = useRef(true);
  const { searchQuery } = useSearch();
  const { currentId } = useParams<{ currentId: any }>();
  const [currentRecord, setCurrentRecord] = useState<any>(null);
  const [rows, setRows] = useState<any[]>([]);
  const { alert, setAlert, handleCloseAlert } = useAlert();
  const [inProgressSend, setInProgressSend] = useState<boolean>(false);
  const [confirmDailogOpen, setConfirmDailogOpen] = useState<boolean>(false);
  const { getAdmin } = useStore();
  const navigate = useNavigate();
  const [orderBy, setOrderBy] = useState<any>('id');
  const [order, setOrder] = useState<SortDirection>('asc');
  const [moreOpen, setMoreOpen] = useState<number[]>([]);
  const toggleBreakdownOpen = (index: number) => {
    setMoreOpen((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    );
  };
  const handleOrderBy = (orderByColumn: any) => {
    setOrderBy(orderByColumn);
    // console.log(order);
    // console.log(orderByColumn);
    if (order === 'desc') {
      setOrder('asc');
      return;
    } else {
      setOrder('desc');
      return;
    }
  };

  useEffect(() => {
    if (isInitialLoad.current) {
      if (currentId) {
        if (parseInt(currentId) > 0) {
          fetchOrderDetails(currentId);
        }
      } else {
        setCurrentRecord(null);
      }

      isInitialLoad.current = false;
    }
  }, [currentId]);
  const columns: any[] = [
    {
      field: 'expand',
      headerName: '',
      width: '48px',
      disableSort: true,
      renderCell: (value: any, row: any) => {
        const hasBreakdown =
          Array.isArray(row.quantityBreakdown) &&
          row.quantityBreakdown.length > 0;
        if (!hasBreakdown) return null;
        const index = rows.findIndex(
          (item: any) => item.inventoryOrderItemId === row.inventoryOrderItemId
        );
        const isOpen = moreOpen.includes(index);
        return (
          <Tooltip
            title={isOpen ? 'Hide calculation' : 'View calculation'}
            arrow
          >
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation();
                toggleBreakdownOpen(index);
              }}
              aria-label={isOpen ? 'Hide calculation' : 'View calculation'}
            >
              {isOpen ? (
                <ExpandLessIcon fontSize="small" />
              ) : (
                <ExpandMoreIcon fontSize="small" />
              )}
            </IconButton>
          </Tooltip>
        );
      },
    },
    {
      field: 'srcName',
      headerName: 'Location',
    },
    {
      field: 'resourceName',
      headerName: 'Resource Items',
    },
    {
      field: 'quantityOrdered',
      headerName: 'Qty to Despatch',
    },

    {
      field: 'quantityReceived',
      headerName: 'Goods Received',
      renderCell: (value: any, row: any) => (
        <Box sx={{ width: 100 }}>
          {currentRecord.orderStatus !== 'completed' ? (
            <TextFieldComponent
              errorStr=""
              type="text"
              isRequired={false}
              keyName={row.resourceId + '_POOrderQty'}
              label=""
              name={row.resourceId + '_POOrderQty'}
              value={value === undefined ? '' : value}
              onChange={(event: any) => {
                const intOnly = String(event.target.value).replace(/\D/g, '');
                const currentIndex = rows.findIndex(
                  (item) =>
                    item.inventoryOrderItemId === row.inventoryOrderItemId
                );
                setRows((prevItems) => {
                  const updatedItems = [...prevItems];
                  if (currentIndex !== -1) {
                    updatedItems[currentIndex]['quantityReceived'] = intOnly;
                  }
                  return updatedItems;
                });
              }}
            />
          ) : (
            value
          )}
        </Box>
      ),
    },
  ];
  const fetchOrderDetails = async (currentId: any) => {
    try {
      const response = await HttpServices.get(
        `${Constants.apiURL + Constants.inventoryURL}/orders/${currentId}`,
        { headers: { Authorization: `Bearer ${getAdmin()}` } },
        {}
      );
      //console.log(response);
      if (response.data) {
        setCurrentRecord(response.data);
        const normalizedItems = (response.data.items || []).map(
          (item: any) => ({
            ...item,
            quantityBreakdown: Array.isArray(item.quantityBreakdown)
              ? item.quantityBreakdown.map((entry: any) => ({
                  qty: String(parseInt(String(entry.qty ?? '0'), 10) || 0),
                  size: String(parseInt(String(entry.size ?? '0'), 10) || 0),
                }))
              : [],
          })
        );
        setRows(normalizedItems);
        const preOpenIndices = normalizedItems
          .map((item: any, idx: number) =>
            item.quantityBreakdown.length > 0 ? idx : -1
          )
          .filter((idx: number) => idx !== -1);
        setMoreOpen(preOpenIndices);
        handleOrderBy('id');
        return true;
      } else {
        return false;
      }
    } catch (error: any) {
      console.error(`Error fetching data:`, error);
      return false;
    }
  };
  const dialogConfirmation = () => {
    return (
      <Box sx={{ width: '450px' }}>
        <h2>Are you sure you want to Finalize items?</h2>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '20px',
          }}
        >
          <ButtonComponent
            errors={[]}
            keyName="okbuttonconfirm"
            label={'Confirm'}
            onClick={async () => {
              handleOrder('completed');
              setConfirmDailogOpen(false);
            }}
          />
        </Box>
      </Box>
    );
  };
  const handleOrder = async (type: string) => {
    try {
      const items: any[] = rows
        .filter(
          (item: any) =>
            item.quantityReceived !== undefined && item.quantityReceived !== ''
        )
        .map((item: any) => ({
          inventoryOrderItemId: item.inventoryOrderItemId,
          quantityReceived: item.quantityReceived,
        }));
      if (items.length === 0) {
        setAlert({
          type: 'error',
          message: 'atleast one quantity is required',
          open: true,
        });
        return false;
      }

      setInProgressSend(true);

      const postData = {
        inventoryOrderId: currentId,
        orderStatus: type,
        items: items,
      };
      const endpoint = `${Constants.apiURL + Constants.inventoryURL}/orders`;
      const response = await HttpServices.put(endpoint, postData, {
        headers: { Authorization: `Bearer ${getAdmin()}` },
      });
      if (response.success) {
        setAlert({
          type: 'success',
          open: true,
          message: 'Saved Successfully',
        });
        navigate('/inventory/material-transfer-po');
      }
    } catch (e: any) {
      setAlert({
        type: 'error',
        open: true,
        message: e.message,
      });
    }
    let errorMessage = '';
    return errorMessage;
  };
  return (
    <Box className="main dashboardmain">
      <section className="section dashboard">
        <div className="containergrid">
          <div className="mt-2">
            <div
              onClick={() => {
                navigate('/inventory/material-transfer-po');
              }}
              style={{
                cursor: 'pointer',
                display: 'inline-flex',
                gap: '8px',
                alignItems: 'center',
                marginBottom: '16px',
              }}
            >
              <UTurnLeftIcon
                sx={{
                  transform: 'rotate(90deg)',
                  cursor: 'pointer',
                }}
              />
              <Typography>Back</Typography>
            </div>
            <Typography variant="h6" sx={{ m: 2 }}>
              Receipting Details
            </Typography>
            <Paper sx={{ width: '100%' }} className="mt-4">
              <Box
                sx={{
                  padding: '24px 16px 16px 16px',
                  mb: 2,
                  display: 'grid',
                  gap: '32px',
                  overflowX: 'scroll',
                }}
              >
                {currentRecord && (
                  <Box
                    sx={{
                      backgroundColor: '#F9F9F9',
                      border: '1px solid #EFEEED',
                      borderRadius: '6px',
                      padding: ' 16px',
                    }}
                  >
                    <Grid container spacing={2}>
                      <Grid size={4}>
                        <h3 className="ovreview-label">Transfer / PO Number</h3>
                        {currentRecord.purchaseOrderNumber}
                      </Grid>

                      <Grid size={4}>
                        <h3 className="ovreview-label">{'Source'}</h3>
                        {currentRecord.srcName}
                      </Grid>
                      <Grid size={4}>
                        <h3 className="ovreview-label">
                          {'Delivery Location'}
                        </h3>
                        {currentRecord.destName}
                      </Grid>
                    </Grid>
                  </Box>
                )}
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '10px',
                  mb: 2,
                }}
              >
                <Typography variant="h6">All Items</Typography>
                {currentRecord && currentRecord.orderStatus !== 'completed' && (
                  <Box sx={{ display: 'flex', gap: 2 }}>
                    <ButtonComponent
                      onClick={() => {
                        setConfirmDailogOpen(true);
                      }}
                      keyName="quoteaddicon"
                      label="Finalise"
                    />

                    <ButtonComponent
                      onClick={() => {
                        handleOrder('pending');
                      }}
                      keyName="quoteaddicon"
                      label="Save & Close"
                    />
                  </Box>
                )}
              </Box>

              <CustomPaginationActionsTable
                rows={rows}
                columns={columns}
                totalRecords={rows.length}
                handlePagination={() => {}}
                isPagingHide={true}
                handleRowClick={(row: any) => {}}
                handleStatus={() => {}}
                order={order}
                orderBy={orderBy}
                handleOrderBy={handleOrderBy}
                paginationModel={{
                  page: 0,
                  pageSize: 25,
                }}
                isMore={true}
                moreOpen={moreOpen}
                renderExpanded={(row: any) => {
                  const breakdown = row.quantityBreakdown || [];
                  if (breakdown.length === 0) return null;
                  const valueSx = {
                    textAlign: 'center' as const,
                    fontSize: 14,
                    color: '#1f2d3d',
                  };
                  const opSx = {
                    color: '#00bcd4',
                    fontWeight: 700,
                    fontSize: 16,
                    textAlign: 'center' as const,
                  };
                  const labelSx = {
                    fontSize: 11,
                    fontWeight: 600,
                    color: '#6b7280',
                    textTransform: 'uppercase' as const,
                    letterSpacing: '0.6px',
                  };
                  return (
                    <Box
                      sx={{
                        my: 1.5,
                        ml: 6,
                        width: 'fit-content',
                        maxWidth: 420,
                        border: '1px solid #e0e7ea',
                        borderLeft: '3px solid #00bcd4',
                        borderRadius: 1.5,
                        backgroundColor: '#fbfdfe',
                        overflow: 'hidden',
                      }}
                    >
                      <Box
                        sx={{
                          px: 2,
                          py: 1.25,
                          backgroundColor: 'rgba(0, 188, 212, 0.06)',
                          borderBottom: '1px solid #e0e7ea',
                        }}
                      >
                        <Typography
                          variant="subtitle2"
                          sx={{ fontWeight: 600, color: '#1f2d3d' }}
                        >
                          Calculation
                        </Typography>
                      </Box>
                      <Box sx={{ p: 2 }}>
                        <Box
                          sx={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 40px 1fr 40px 1fr',
                            columnGap: 2,
                            alignItems: 'center',
                            pb: 1,
                            mb: 1,
                            borderBottom: '1px solid #eef1f3',
                          }}
                        >
                          <Box sx={{ ...labelSx, textAlign: 'center' }}>
                            Qty
                          </Box>
                          <Box />
                          <Box sx={{ ...labelSx, textAlign: 'center' }}>
                            Size
                          </Box>
                          <Box />
                          <Box sx={{ ...labelSx, textAlign: 'center' }}>
                            Subtotal
                          </Box>
                        </Box>
                        {breakdown.map((entry: any, i: number) => {
                          const subtotal =
                            (Number(entry.qty) || 0) *
                            (Number(entry.size) || 0);
                          return (
                            <Box
                              key={`receipt_breakdown_${row.inventoryOrderItemId}_${i}`}
                              sx={{
                                display: 'grid',
                                gridTemplateColumns: '1fr 40px 1fr 40px 1fr',
                                columnGap: 2,
                                alignItems: 'center',
                                py: 0.75,
                                '&:not(:last-child)': {
                                  borderBottom: '1px dashed #f0f3f5',
                                },
                              }}
                            >
                              <Box sx={valueSx}>{entry.qty}</Box>
                              <Box sx={opSx}>×</Box>
                              <Box sx={valueSx}>{entry.size}</Box>
                              <Box sx={opSx}>=</Box>
                              <Box
                                sx={{
                                  textAlign: 'center',
                                  fontWeight: 700,
                                  fontSize: 15,
                                  color: '#001e3c',
                                }}
                              >
                                {subtotal}
                              </Box>
                            </Box>
                          );
                        })}
                      </Box>
                    </Box>
                  );
                }}
              />
            </Paper>
          </div>
        </div>
      </section>
      <SimpleDialogComponent
        title={'Confirmation'}
        dialogContent={dialogConfirmation()}
        open={confirmDailogOpen}
        handleClose={() => {
          setConfirmDailogOpen(false);
        }}
      />
      <AlertMessageComponent
        type={alert.type}
        open={alert.open}
        handleClose={handleCloseAlert}
        message={alert.message}
      />
    </Box>
  );
};

export default ReceiptingDetails;
